import { render } from "./photoshop.vue?vue&type=template&id=47d6e71c"
import script from "./photoshop.vue?vue&type=script&lang=js"
export * from "./photoshop.vue?vue&type=script&lang=js"

import "./photoshop.vue?vue&type=style&index=0&id=47d6e71c&lang=css"
script.render = render

export default script